import { ReactNode } from 'react';
import { InlineLink, Surface } from '@vst/beam';
import { Trans, useTranslation } from 'react-i18next';

import PlanAttribute from '../../PlanAttribute';

type VoicePlanDetailsProps = {
  showCAFText: boolean;
  features: string[];
};

const VoicePlanDetails = ({ showCAFText, features }: VoicePlanDetailsProps) => {
  const { t } = useTranslation('ChangePlan');

  return (
    <Surface>
      {showCAFText && (
        <PlanAttribute>
          <Trans
            t={t}
            i18nKey="plan.cafII.primaryText"
            values={{ clickHere: t('plan.cafII.clickHere') }}
            components={[
              <strong key={'strong'} />,
              <InlineLink
                key={'link'}
                href={t('plan.satelliteInternetLink')}
                target="_blank"
                style={{ color: 'inherit' }}
              >
                {''}
              </InlineLink>,
            ]}
          />
        </PlanAttribute>
      )}

      {features.map((feature, idx) => (
        <PlanAttribute key={idx}>{feature}</PlanAttribute>
      ))}
    </Surface>
  );
};

export default VoicePlanDetails;
